export default __webpack_public_path__ + "static/media/PPI-driveway-013.57333817.jpg";